import React from 'react';
import {Paper, Typography, IconButton, Link, Box, Stack} from '@mui/material';
import style from '../../css/footer.module.css';
import { Email,Facebook,Instagram,Twitter,YouTube } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { data } from '../../storeredux';

export default function Footer() {
  const { socialmedia } = useSelector(data)
  const switchIcon = (data) => {
    if (data === 'email') return <Email className={style.Button}/>
    if (data === 'facebook') return <Facebook className={style.Button}/>
    if (data === 'twitter') return <Twitter className={style.Button}/>
    if (data === 'instagram') return <Instagram className={style.Button}/>
    if (data === 'youtube') return <YouTube className={style.Button}/>
  }
  return(
    <>
      <Paper id='Contact' style={{backgroundColor: '#00cc66',width: '100%'}}>
        <Box className={style.Paper}>
          <Box className={style.PaperSec}>
            <Typography className={style.containment}>
              <div className={style.containmentBody}>Copyright © MPQ UMS 2021</div>
            </Typography>
          </Box>
          <Box className={style.PaperSec}>
            <Stack direction={'row'} style={{justifyContent:'center',alignItems:'center'}} spacing={2}>
                {
                  socialmedia.map((dt,i) => (
                    <IconButton key={i} href={`${(Object.keys(dt)[0] === 'email')?'mailto:':''}${Object.values(socialmedia[i])[0]}`} style={{backgroundColor: '#00b359'}}>
                      {switchIcon(Object.keys(dt)[0])}
                    </IconButton>
                  ))
                }
            </Stack>
          </Box>
          <Box className={style.PaperSec}>
            <Typography className={style.containment}>
              <Link href="#" underline='none' rel="noopener" className={style.containmentBody} style={{color:'white'}}>
                Privacy Policy
              </Link>
            </Typography>
          </Box>
        </Box>
      </Paper>
    </>
  );
}
